// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const qrCodeEntryPointTypeEnum = {
  QR_CODE: "QR_CODE",
} as const;

export type QrCodeEntryPointTypeEnumKey =
  (typeof qrCodeEntryPointTypeEnum)[keyof typeof qrCodeEntryPointTypeEnum];

export const qrCodeTypeEnum = {
  VANCE_QR_CODE: "VANCE_QR_CODE",
} as const;

export type QrCodeTypeEnumKey =
  (typeof qrCodeTypeEnum)[keyof typeof qrCodeTypeEnum];

export type QrCode = {
  /**
   * @type string
   */
  entryPointType: QrCodeEntryPointTypeEnumKey;
  /**
   * @type string
   */
  sessionId: string;
  /**
   * @type string
   */
  state: string;
  /**
   * @type string
   */
  type: QrCodeTypeEnumKey;
  /**
   * @type string
   */
  workspaceId: string;
};
